import React, { useEffect, useState } from 'react';
import { Gene, blankGene } from '../../types/Gene.ts';
import { GeneInput } from './GeneInput.tsx';
import { makeMorphNameStringPotential } from '../../utils/GeneCalculator.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Morph } from '../../types/Morph.ts';


export const MorphGeneInputs = ({ genes, setMorphName, morphs, presetGenes, setCurrentGenes = (genes: Gene[]) => { } }: {
  genes: Gene[],
  setMorphName: (morphName: string) => void,
  morphs: Morph[],
  presetGenes?: Gene[],
  setCurrentGenes?: (genes: Gene[]) => void
}) => {
  const [selectedGenes, setSelectedGenes] = useState<Gene[]>(presetGenes || [blankGene]);

  useEffect(() => {
    const result = makeMorphNameStringPotential(selectedGenes, morphs);
    setMorphName(result);

    setCurrentGenes(selectedGenes.filter(gene => gene.gene_name !== ''));
  }, [selectedGenes])

  return (
    <>
      {selectedGenes.map((gene, index) => {
        return (<div className='mt-3' key={index}>
          <GeneInput
            id={`genes-${index}`}
            genes={genes.filter(fGene => selectedGenes.find(selectedGene => selectedGene.gene_name === fGene.gene_name) === undefined || gene.gene_name === fGene.gene_name)}
            gene={gene}
            setGene={(geneData) => {
              const updateGenes = [...selectedGenes];
              updateGenes[index] = geneData;
              setSelectedGenes(updateGenes);
            }}
          />
        </div>
        )
      })}
      {!selectedGenes.some(gene => gene.gene_name === "") && <div className="mt-3">
        <span className="add-another-gene mt-4" onClick={() => setSelectedGenes([...selectedGenes, blankGene])}>
          <FontAwesomeIcon icon={faPlus} /> Add Additional Gene
        </span>
      </div>}
    </>
  )
}
